var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spwwFooterPage" }, [
    _c("div", { staticClass: "mainCont" }, [
      _c("div", { staticClass: "footer" }, [
        _c("span", { staticStyle: { "padding-right": "5px" } }, [
          _vm._v(_vm._s(_vm.$t("copyright"))),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticStyle: { "margin-left": "10px" },
            attrs: { href: "http://beian.miit.gov.cn", target: "_blank" },
          },
          [_vm._v(_vm._s(_vm.$t("forTheRecord")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }